export const requiredKeys = [
  'annotation',
  'emoji',
  'group',
  'order',
  'version'
]
